import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgPolylineComponent } from './svgpolyline.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [SvgPolylineComponent],
  exports: [SvgPolylineComponent]
})
export class SvgPolylineModule { }
